import React, { useState, useEffect } from 'react';

//material mui components
import { Avatar, Typography } from '@mui/material';

//hooks
import { useGlobalState } from '../../../Utilidades/useGlobalState';

//activos
import BannerLogoSvg from '../../../Activos/Imagenes/Modulos/Home/BannerLogo.svg';
import BannerFooterSvg from '../../../Activos/Imagenes/Modulos/Home/BannerFooter.svg';
import BannerFooterRigthSvg from '../../../Activos/Imagenes/Modulos/Home/BannerFooterRigth.svg';
import LoginTemp from '../../../Activos/Imagenes/Modulos/LoginTemp.svg';

//actions
import { obtenerListadoCompaniaPortales } from '../../../Actions/Companias/CompaniaAction';

//styles
import { StyleBannerLateral } from '../../Tool/Style'

const BannerLateral = () => {
    const { etiquetas, compania } = useGlobalState();
    const [imagenLogoInicio, setImagenLogoInicio] = useState('');

 
    useEffect(() => {
        const compId = compania.ComCompanyId;
        if (compId !== null && compId !== undefined && compId !== "") {
            obtenerListaCompanias(compId);
        }
    }, [compania.ComCompanyId]);

    function encuentraCompaniaInicialId(compania, idBuscar) {
        return compania.companyId.toLowerCase() === idBuscar.toLowerCase();
    }

    const obtenerListaCompanias = async (compId) => {
        const objetoListar = {
        };

        await obtenerListadoCompaniaPortales(objetoListar).then(response => {
            if (response.status === 200) //si la respuesta fue existosa 
            {
                // se asigna al objeto de variable de estado local la respuesta 
                const listadoTemp = response.data;

                const compTemp = listadoTemp.find(comp => encuentraCompaniaInicialId(comp, compId));

                if (compTemp) {
                    setImagenLogoInicio(compTemp.companyImage);
                }
            }
            else {
                setImagenLogoInicio('');
            }
        });
    };

    return (
        <div style={StyleBannerLateral.Image}>
            <div style={StyleBannerLateral.Conteiner}>
                <img style={{ ...StyleBannerLateral.LogoSvg, ...{ width: "200px", height: "115px", objectFit: "scale-down" } }}
                    src={(imagenLogoInicio === '' ? BannerLogoSvg : imagenLogoInicio)} alt={"Logo de Class"} />
                <Typography style={StyleBannerLateral.FontStyle}>{etiquetas.Home.Et_lblHola}</Typography>
                <Typography style={{
                    ...StyleBannerLateral.FontStyle, ...{
                        fontSize: 40, lineHeight: 1.2, letterSpacing: 0.25
                    }
                }}>{etiquetas.Home.Et_lblSaludosDia}</Typography>
                <Typography style={{ ...StyleBannerLateral.FontStyle, ...{ fontWeight: 400, fontSize: 18 } }}>{etiquetas.Home.Et_lblDescripcion}</Typography>
                <Avatar sx={StyleBannerLateral.FloatFooterImage} aria-label="recipe">
                    <img style={StyleBannerLateral.FooterImage} src={BannerFooterSvg} alt={"Avatar de Footer"} />
                </Avatar>
                <img style={StyleBannerLateral.FooterImageRigth} src={BannerFooterRigthSvg} alt={"Avatar de FooterRigth"} />
                <img src={LoginTemp} alt={"Imagen de Registro"} style={{ position: "absolute", right: "20px", bottom: "60px", height: "25px", width: "153px" }} />
            </div>
        </div>
    );
};

export default BannerLateral;